const createCommonKeys = (
  title = 'Seznam položek',
  titleDeleted = 'Seznam smazaných položek',
  detailTitle = 'Detail',
  deleteEntity = 'Smazat položku'
) => ({ title, titleDeleted, detailTitle, deleteEntity })

export const initialState = {

  language: 'cs-CZ',
  locale: 'cs',
  data: {
    common: {
      'unknownError': 'Došlo k neznámé chybě. Prosím, zkuste to později.',
      'pageNotExist': 'Požadovaná stránka neexistuje.',
      'winelist': 'WINELIST',
      'copyright': 'WineList s.r.o., všechna práva vyhrazena.',
      'cancel': 'Zrušit',
      'confirm': 'Potvrzení',
      'defaultConfirmMessage': 'Prosím, potvrďte akci.',
      'yes': 'Ano',
      'no': 'Ne',
      'ok': 'OK',
      'refresh': 'Obnovit',
      'refreshTitle': 'Znovu načíst data',
      'errorOccurred': 'Došlo k chybě.',
      'tryAgain': 'Zkusit znovu',
      'logout': 'Odhlásit',
      'momentPlease': 'Moment, prosím...',
      'signedInUser': 'Přihlášený uživatel: ',
      'releaseNotes': 'Poznámky k verzím',
      'clearFilter': 'Smazat filtr',
      'add': 'Přidat',
      'addTooltip': 'Přidat nový záznam',
      'trash': 'Koš',
      'goBack': 'Vrátit se zpět',
      'name': 'Název',
      'order': 'Pořadí',
      'title': 'Titulek',
      'delete': 'Smazat',
      'save': 'Uložit',
      'saveAsNew': 'Uložit jako nové',
      'saveAsNewTooltip': 'Namísto aktualizace stávajícího záznamu, vytvoří záznam nový',
      'saved': 'Uloženo.',
      'allSaved': 'Záznamy uloženy. Celkem: {0}',
      'deleted': 'Smazáno.',
      'id': 'ID',
      'gridCheckAll': 'Zaškrtnout všechny boxy na aktuální stránce',
      'gridUncheckAll': 'Odškrtnout všechny boxy na aktuální stránce',
      'gridDeselectAllConfirm': 'Opravdu chcete odškrtnout položky ze všech stránek?',
      'gridDeselectAllTooltip': 'Odškrtnout položky ze všech stránek',
      'noRecords': 'Žádný záznam',
      'confirmDelete': `Opravdu chcete '{0}' přesunout do koše?`,
      'confirmDeleteOnDetailPage': `Opravdu chcete tuto položku přesunout do koše?`,
      'confirmHardDeleteOnDetailPage': 'Opravdu chcete tuto položku trvale smazat?',
      'genericConfirmDelete': 'Opravdu chcete tuto položku odstranit?',
      'restoreFromTrash': 'Obnovit z koše',
      'restored': 'Obnoveno.',
      'hardDeleteEntity': 'Trvale smazat',
      'confirmHardDelete': `Opravdu chcete '{0}' trvale smazat?`,
      'hardDeleted': 'Nevratně smazáno.',
      'emptyTrash': 'Vysypat koš',
      'confirmEmptyTrash': 'Opravdu chcete vysypat koš?',
      'trashEmptied': 'Koš byl vysypán.',
      'toggleMenu': 'Sbalit/rozbalit menu',
      'formContainsValidationErrors': 'Formulář obsahuje chyby',
      'selectValue': 'Vyberte ze seznamu...',
      'userNotSignIn': 'Uživatel odhlášen',
      'loginAgain': 'Znovu přihlásit',
      'editItemButtonTitle': 'Upravit seznam položek',
      'addItemButtonTitle': 'Přidat novou položku',
      'list': 'Seznam',
      'loading': 'Načítání ...',
      'notImplementedYet': 'Zatím neimplementováno...',
      'massEditFormat': '{0} - hromadná editace (celkem záznamů: {1})',
      'exportTooltip': 'Exportovat do excelu',
      'export': 'Export',
      'imageDetailTitle': 'Detail obrázku',
      'edit': 'Upravit',
      'multiSelect': 'Multiselect',
      'multiSelectTooltip': 'Zapnout/vypnout multi-select',
      'address': 'Ulice',
      'address2': 'Doplnění adresy',
      'zipCode': 'PSČ',
      'city': 'Město',
      'web': 'WWW',
      'email': 'Email',
      'saveAndGoToList': 'Uložit a přejít zpět na seznam'
    },
    menu: {
      'dashboard': 'Dashboard',
      'orders': 'Objednávky',
      'bottles': 'Seznam lahví',
      'bottlesWineEditor': 'Seznam lahví (WE)',
      'winesInStock': 'Vína na skladě',
      'settings': 'Nastavení',
      'lookups': 'Číselníky',
      'grapes': 'Odrůdy vína',
      'wineStyles': 'Styly vína',
      'producers': 'Vinaři',
      'storagePlaces': 'Sklady',
      'suppliers': 'Dodavatelé',
      'regions': 'Regiony',
      'countries': 'Státy',
      'districts': 'Oblasti',
      'subdistricts': 'Podoblasti',
      'wines': 'Seznam vín',
      'ordersList': 'Seznam',
      'ordersProcessing': 'Naskladnění',
      'currencies': 'Seznam měn',
      'produceStyles': 'Styl výroby',
      'vineyardStyles': 'Styl vinohradnictví',
      'wineTypes': 'Typy vína',
      'classificationByOrigins': 'Klasifikace dle původu',
      'classificationByParamses': 'Klasifikace dle parametrů',
      'evaluators': 'Hodnotileté',
      'flavourCharacteristicses': 'Charakteristiky vůní a chutí'
    },
    validations: {
      'required': 'Toto pole je povinné',
      'arrayRequired': 'Musí obsahovat alespoň jednu položku',
      'invalidFormat': 'Neplatný formát',
      'maxLengthExceeded': 'Maximální povolená délka je {0}',
      'lessThanMinValue': 'Minimální povolená hodnota je {0}',
      'maxValueExceeded': 'Maximální povolená hodnota je {0}',
      'emailAlreadyExists': 'Tento email již v systému existuje',
      'errorOccurred': 'Došlo k chybě: {0}'
    },
    enums: {
      'grapeType_-1': '-',
      'grapeType_0': 'Bílé',
      'grapeType_1': 'Červené',
      'grapeType_2': 'Růžové',
      'grapeType_3': 'Oranžové',
      'yesNoAllEnum_1': '-',
      'yesNoAllEnum_2': 'Ne',
      'yesNoAllEnum_3': 'Ano',
      'orderStatus_0': 'Nová',
      'orderStatus_1': 'Odeslána',
      'orderStatus_2': 'Nedodáno',
      'orderStatus_3': 'Částečně dodáno',
      'orderStatus_4': 'Dodáno',
      'bottleStatus_0': 'Skladem',
      'bottleStatus_1': 'Prodáno',
      'holdingStrategy_0': 'Okamžitý prodej',
      'holdingStrategy_1': 'Dlouhodobé skladování',
      'holdingStrategy_2': 'Ostatní',
      'holdingStrategy_3': 'Investice',
      'storageStatus_0': 'Objednáno',
      'storageStatus_1': 'Na skladě',
      'storageStatus_2': 'Prodáno',
      'storageStatus_3': 'Zničena/Poškozena',
      'storageStatus_4': 'Ztracena',
      'soldByChannel_0': 'Bar',
      'soldByChannel_1': 'Prodejní automat',
      'soldByChannel_2': 'Kamenný obchod',
      'soldByChannel_3': 'e-Shop',
      'soldByChannel_4': 'Ostatní',
      'logicOptions_0': 'Nebo (OR)',
      'logicOptions_1': 'A zároveň (AND)',
      'bottleVolume_0': '0,375 l',
      'bottleVolume_1': '0,500 l',
      'bottleVolume_2': '0,750 l',
      'bottleVolume_3': '1,500 l',
      'bottleVolume_4': 'jiná',
      'paymentType_0': 'Kartou',
      'paymentType_1': 'Bankovním převodem',
      'loweIndex_1': 'Jiné',
      'loweIndex_24': 'LOWE 24',
      'loweIndex_240': 'LOWE 240',
      'loweIndex_1000': 'LOWE 1000',
      'tannins_0': 'low',
      'tannins_1': 'medium(-)',
      'tannins_2': 'medium',
      'tannins_3': 'medium(+)',
      'tannins_4': 'high',
      'tannins_5': 'na',
      'mousse_0': 'delicate',
      'mousse_1': 'creamy',
      'mousse_2': 'aggressive',
      'mousse_3': 'na',
      'sweetness_0': 'dry',
      'sweetness_1': 'off-dry',
      'sweetness_2': 'medium-dry',
      'sweetness_3': 'medium-sweet',
      'sweetness_4': 'sweet',
      'finish_0': 'short',
      'finish_1': 'medium(-)',
      'finish_2': 'medium',
      'finish_3': 'medium(+)',
      'finish_4': 'long',
      'body_0': 'light',
      'body_1': 'medium(-)',
      'body_2': 'medium',
      'body_3': 'medium(+)',
      'body_4': 'full',
      'alcohol_0': 'low',
      'alcohol_1': 'medium',
      'alcohol_2': 'high',
      'acidity_0': 'low',
      'acidity_1': 'medium(-)',
      'acidity_2': 'medium',
      'acidity_3': 'medium(+)',
      'acidity_4': 'high',
      'aromaFlavourIntensity_0': 'light',
      'aromaFlavourIntensity_1': 'medium(-)',
      'aromaFlavourIntensity_2': 'medium',
      'aromaFlavourIntensity_3': 'medium(+)',
      'aromaFlavourIntensity_4': 'pronounced',
      'colour_0': 'lemon',
      'colour_1': 'gold',
      'colour_2': 'amber',
      'colour_3': 'brown',
      'colour_4': 'pink',
      'colour_5': 'pink-orange',
      'colour_6': 'orange',
      'colour_7': 'purple',
      'colour_8': 'ruby',
      'colour_9': 'garnet',
      'colour_10': 'tawny',
      'colourIntensity_0': 'pale',
      'colourIntensity_1': 'medium',
      'colourIntensity_2': 'deep',
      'wsetType_0': 'Colour intensity',
      'wsetType_1': 'Colour',
      'wsetType_2': 'Aroma & flavour intensity',
      'wsetType_3': 'Aroma & flavour characteristics',
      'wsetType_4': 'Sweetness',
      'wsetType_5': 'Acidity',
      'wsetType_6': 'Tannins',
      'wsetType_7': 'Alcohol',
      'wsetType_8': 'Body',
      'wsetType_9': 'Finish',
      'wsetType_10': 'Mousse',
    },
    filters: {
      'title': 'Filtry',
      'add': 'Přidat filtr',
      'addFiltersTooltip': 'Vytvořit novou skupinu filtrů',
      'clear': 'Vyčistit filtry',
      'apply': 'Aplikovat filtr',
      'confirmDelete': `Opravdu chcete filtry '{0}' trvale smazat?`,
      'logicOperator': 'Logický operátor',
      'numeric_equal': 'Je rovno',
      'numeric_not-equal': 'Nerovná se',
      'numeric_less-than': 'Je menší než',
      'numeric_less-or-equal': 'Je menší nebo rovno',
      'numeric_greater-or-equal': 'Je větší nebo rovno',
      'numeric_greater-than': 'Je větší než',
      'date_equal': 'Je rovno',
      'date_not-equal': 'Nerovná se',
      'date_less-than': 'Je menší než',
      'date_less-or-equal': 'Je menší nebo rovno',
      'date_greater-or-equal': 'Je větší nebo rovno',
      'date_greater-than': 'Je větší než',
      'date_is-null': 'Nemá hodnotu',
      'date_is-not-null': 'Má hodnotu',
      'string_startswith': 'Začíná na',
      'string_endswith': 'Končí na',
      'string_contains': 'Obsahuje',
      'string_doesnotcontain': 'Neobsahuje',
      'string_isempty': 'Je prázdný',
      'string_isnotempty': 'Není prázdný',
      'enum_equal': 'Je rovno',
      'enum_not-equal': 'Nerovná se',
      'lookup_equal': 'Je rovno',
      'lookup_not-equal': 'Nerovná se',
      
      'column_wineName': 'Název vína',
      'column_classificationByOriginId': 'Klasifikace dle původu',
      'column_classificationByParamsId': 'Klasifikace dle parametrů',
      'column_wineTypeId': 'Typ vína',
      'column_supplierName': 'Dodavatel',
      'column_dateOfOrder': 'Datum objednávky',
      'column_status': 'Stav',
      'column_dateOfArrival': 'Datum dodání',
      'column_expiration': 'Expirace',
      'column_dateOfSale': 'Datum prodeje',
      'column_acquisitionPrice': 'Pořizovací cena (bez DPH)',
      'column_actualPrice': 'Cena (bez DPH)',
      'column_description': 'Popis vína',
      'column_loweIndex': 'LOWE index',
      'column_expQuality': 'Předpokládaná kvalita',
      'column_alcohol': 'Alkohol (g/l)',
      'column_acidity': 'Kyselina (g/l)',
      'column_sugar': 'Cukr (g/l)',
      'column_customerRating': 'Zákaznické hodnocení',
      'column_storageLocation': 'Umístění ve skladu',
      'column_holdingStrategy': 'Strategie prodeje',
      'column_storageStatus': 'Stav lahve',
      'column_soldByChannel': 'Prodejní kanál',
      'column_temperature': 'Teplota ve stroji',
      'column_storagePlaceId': 'Sklad',
      'column_subregionId': 'Region',
      'column_winery': 'Vinařství',
      'column_regionId': 'Region',
      'column_countryId': 'Země',
      'column_districtId': 'Oblast',
      'column_subdistrictId': 'Podoblast'
    },
    suppliers: {
      ...createCommonKeys(
        'Seznam dodavatelů',
        'Seznam smazaných dodavatelů',
        'Dodavatel',
        'Smazat dodavatele'
      ),
      'grape': 'Odrůda vína',
      'dateOfFirstOrder': 'Datum první objednávky',
      'totalBottles': 'Počet objednaných lahví celkem',
      'totalPrice': 'Celková suma (bez DPH)',
      'country': 'Stát',
      'city': 'Město',
      'address': 'Ulice',
      'taxIdentificationNumber': 'DIČ',
      'bankAccount': 'Bankovní účet',
      'phoneNumber': 'Telefon',
      'comment': 'Komentář',
    },
    releaseNotes: {
      'title': 'Poznámky v verzím'
    },
    winesInStock: {
      'title': 'Vína na skladě',
      'bottlesOnStockCount': 'Počet lahví na skladě'
    },
    grapes: {
      ...createCommonKeys(
        'Seznam odrůd vína',
        'Seznam smazaných odrůd',
        'Odrůda',
        'Smazat odrůdu'
      ),
      'tag': 'Druh'
    },
    wineStyles: {
      ...createCommonKeys(
        'Seznam stylů vína',
        'Seznam smazaných stylů',
        'Styl vína',
        `Opravdu chcete styl '{0}' přesunout do koše?`,
        'Smazat styl'
      )
    },
    evaluators: {
      ...createCommonKeys(
        'Seznam hodnotitelů',
        'Seznam smazaných hodnotitelů',
        'Hodnotitel',
        `Opravdu chcete hodnotitele '{0}' přesunout do koše?`,
        'Smazat hodnotitele'
      )
    },
    wineTypes: {
      ...createCommonKeys(
        'Seznam typů vína',
        'Seznam smazaných typů',
        'Typ vína',
        `Opravdu chcete typ '{0}' přesunout do koše?`,
        'Smazat typ vína'
      )
    },
    classificationByOrigins: {
      ...createCommonKeys(
        'Seznam klasifikací dle původu',
        'Seznam smazaných klasifikací',
        'Klasifikace dle původu',
        `Opravdu chcete klasifikaci '{0}' přesunout do koše?`,
        'Smazat klasifikaci'
      )
    },
    classificationByParamses: {
      ...createCommonKeys(
        'Seznam klasifikací dle parametrů',
        'Seznam smazaných klasifikací',
        'Klasifikace dle parametrů',
        `Opravdu chcete klasifikaci '{0}' přesunout do koše?`,
        'Smazat klasifikaci'
      )
    },
    flavourCharacteristicses: {
      ...createCommonKeys(
        'Seznam charakteristik',
        'Seznam smazaných charakteristik',
        'Charakteristika',
        `Opravdu chcete charackeritiku '{0}' přesunout do koše?`,
        'Smazat charakteristiku'
      )
    },
    producers: {
      ...createCommonKeys(
        'Seznam vinařů',
        'Seznam smazaných vinařů',
        'Vinař',
        'Smazat vinaře'
      ),
      'vineyardStyle' : 'Styl vinohradnictví',
      'produceStyle' : 'Styl výroby vína',
      'country': 'Stát',
      'phoneNumber': 'Telefonní číslo',
      'saveAsSupplier': 'Uložit jako dodavatele',
      'saveAsSupplierTitle': 'Namísto aktualizace vinaře vytvoří ze stávajících dat záznam pro nového dodavatele'
    },
    currencies: {
      ...createCommonKeys(
        'Seznam měn',
        'Seznam smazaných měn',
        'Měna',
        'Smazat měnu'
      ),
      'hint': 'Použijte 3-písmenný ISO kód měny (EUR, USD, GBP)'
    },
    wines: {
      ...createCommonKeys(
        'Seznam vín',
        'Seznam smazaných vín',
        'Víno',
        'Smazat víno'
      ),
      'vintage': 'Ročník',
      
      'producer': 'Vinař',
      'wineStyle': 'Styl vína',
      'grape': 'Odrůda',
      'additionalGrape1': 'Odrůda I',
      'additionalGrape2': 'Odrůda II',
      'additionalGrape3': 'Odrůda III',
      'region': 'Region',
      'country': 'Země',
      'district': 'Oblast',
      'subdistrict': 'Podoblast',
      'bottleVolume': 'Objem lahve',
      'comment': 'Komentář',
      'removeImageTooltip': 'Odstranit obrázek',
      'wineType': 'Typ vína',
      'alcohol': 'Alkohol (g/l)',
      'acidity': 'Kyselina (g/l)',
      'sugar': 'Cukr (g/l)',
      'classificationByOrigin': 'Klasifikace dle původu',
      'classificationByParams': 'Klasifikace dle parametrů',
      'wineEvaluations': 'Hodnocení (max. 4)',
      'addWineEvaluation': 'Přidat hodnocení',
      'evaluator': 'Hodnotitel',
      'evaluation': 'Hodnocení',
      'removeEvaluationTooltip': 'Odstranit toto hodnocení',
      'wsetEvaluationsTitle': 'WSET hodnocení',
      'wsetType': 'Typ'
    },
    storagePlaces: {
      ...createCommonKeys(
        'Seznam skladů',
        'Seznam smazaných skladů',
        'Sklad',
        'Smazat sklad'
      ),
      'capacityInLitres': 'Kapacita skladu v litrech',
      'capacityInBottlesCount': 'Kapacita skladu v počtu lahví',
      'temperature': 'Teplota skladu',
      'comment': 'Komentář'
    },
    regions: {
      ...createCommonKeys(
        'Seznam regionů',
        'Seznam smazaných regionů',
        'Region',
        'Smazat region'
      ),
      'country': 'Země',
      'district': 'Oblast',
      'subdistrict': 'Podoblast',
      'comment': 'Komentář'
    },
    countries: {
      ...createCommonKeys(
        'Seznam států',
        'Seznam smazaných států',
        'Stát',
        'Smazat stát'
      )
    },
    districts: {
      ...createCommonKeys(
        'Seznam oblastí',
        'Seznam smazaných oblastí',
        'Oblast',
        'Smazat oblast'
      )
    },
    subdistricts: {
      ...createCommonKeys(
        'Seznam podoblastí',
        'Seznam smazaných podoblastí',
        'Podoblast',
        'Smazat podoblast'
      )
    },
    produceStyles: {
      ...createCommonKeys(
        'Seznam stylů výroby',
        'Seznam smazaných stylů výroby',
        'Styl výroby',
        'Smazat styl výroby'
      ),
    },
    vineyardStyles: {
      ...createCommonKeys(
        'Seznam stylů vinohradnictví',
        'Seznam smazaných stylů vinohradnictví',
        'Styl vinohradnictví',
        'Smazat styl vinohradnictví'
      ),
    },
    orders: {
      ...createCommonKeys(
        'Seznam objednávek',
        'Seznam smazaných objednávek',
        'Objednávka',
        'Smazat objednávku'
      ),
      'supplier': 'Dodavatel',
      'dateOfOrder': 'Datum objednávky',
      'status': 'Stav objednávky',
      'orderedWines': 'Objednaná vína',
      'addWine': 'Přidat víno',
      'wine': 'Víno',
      'units': 'Počet lahví',
      'price': 'Cena za láhev (bez DPH)',
      'totalUnits': 'Lahví celkem',
      'totalPrice': 'Cena celkem (bez DPH)',
      'processOrder': 'Naskladnit',
      'sentOrder': 'Odeslat objednávku',
      'currency': 'Měna',
      'exchangeRate': 'Kurz',
      'exchangeRatePlaceholder': 'např: 26.75643',
      'sentOrderTooltip': 'Přepne objednávku do stavu Odesláno a již ji nebude možno měnit',
      'confirmSentOrder': 'Opravdu chcete objednávku odeslat? Po odeslání již nebude možné změnit dodavatele ani objednaná vína.',
      'dateOfPayment': 'Datum platby',
      'paymentType': 'Způsob platby',
    },
    orderedWineDialog: {
      'title': 'Objednané víno',
      'wine': 'Víno',
      'units': 'Počet lahví',
      'price': 'Cena za láhev (bez DPH)',
      'confirmDeleteWine': 'Opravdu chcete tuto položku odstranit? K promítnutí změn v databázi je nutno uložit ještě i objednávku.'
    },
    ordersProcessing: {
      'detailTitle': 'Naskladnění',
      'supplier': 'Dodavatel',
      'dateOfOrder': 'Datum objednávky (rozmezí)',
      'filter': 'Najít',
      'wineName': 'Název vína',
      'orderedUnits': 'Objednaných lahví / již naskladněno',
      'priceInOrder': 'Cena v objednávce (bez DPH)',
      'deliveredUnits': 'Dodaných lahví',
      'actualPrice': 'Cena lahve (bez DPH)',
      'createBottles': 'Naskladnit lahve',
      'bottlesCreated': 'Lahve vytvořeny (celkem {0})',
      'bottlesStored': '{0} Lahví vytvořeno, {1} lahví upraveno',
      'dateOfArrival': 'Datum naskladnění',
      'storagePlace': 'Sklad',
      'expiration': 'Expirace'
    },
    bottlesSimple: {
      ...createCommonKeys(
        'Seznam lahví',
        'Seznam smazaných lahví',
        'Láhev',
        'Smazat láhev'
      ),
    },
    bottles: {
      ...createCommonKeys(
        'Seznam lahví',
        'Seznam smazaných lahví',
        'Láhev',
        'Smazat láhev'
      ),
      'wineTitle': 'Víno (celkem lahví: {0})',
      'wineDescription':'Popis vína',
      'wine': 'Víno',
      'pleaseSelectWine': 'Prosím, vyberte víno.',
      'editWine': 'Upravit ...',
      'wineName': 'Název vína',
      'vintage': 'Ročník',
      'supplierName': 'Dodavatel',
      'dateOfOrder': 'Datum objednávky',
      'status': 'Stav',
      'dateOfArrival': 'Datum dodání',
      'expiration': 'Expirace',
      'dateOfSale': 'Datum prodeje',
      'acquisitionPrice': 'Pořizovací cena (bez DPH)',
      'actualPrice': 'Cena (bez DPH)',
      'description': 'Popis',
      'loweIndex': 'LOWE index',
      'expQuality': 'Přepokládaná kvalita',
      'quality': 'Kvalita',
      'customerRating': 'Zákaznické hodnocení',
      // 'externalRating1': 'Vivino',
      // 'externalRating2': 'WS',
      // 'externalRating3': 'RP',
      'holdingStrategy': 'Strategie prodeje',
      'bottleStatus': 'Stav lahve',
      'storageStatus': 'Stav uskladnění',
      'soldByChannel': 'Prodejní kanál',
      'temperature': 'Teplota ve stroji',
      'storagePlace': 'Sklad',
      'winery': 'Vinařství',
      'country': 'Země',
      'district': 'Oblast',
      'subdistrict': 'Podoblast',
      'region': 'Region',
      'excelExportEnqueued': 'Export lahví vložen do fronty.',
      'excelExportStarted': 'Zahájen export lahví do excelu.',
      'excelExportFinished': 'Export lahví do excelu je úspěšně dokončen.',
      'excelExportFinishedWithError': 'Export lahví do excelu selhal',
      'storageLocation': 'Umístění ve skladu',
      'sellInBarButton': 'Prodat v baru',
      'sellInMachineButton': 'Prodat ve stroji',
      'sellInShopButton': 'Prodat v obchodě',
      'sellInEShopButton': 'Prodat v e-shopu',
      'sellInOtherWayButton': 'Prodat jinak',
      'bottlesSold': 'Označené lahve byly označeny jako prodané.',
    },
    addFilterDialog: {
      'title': 'Přidat filtr',
      'select': 'Vyberte sloupec'
    },
    notifications: {
      'title': 'Notifikace',
      'noNotification': 'Žádná oznámení',
      'action_0': 'Export lahví do excelu'
    },
    fileAttachments: {
      'title': 'Soubory ke stažení',
      'deleteFileTooltip': 'Smazat soubor na serveru',
      'confirmDelete': `Opravdu chcete smazat soubor '{0}' ?`,
      'noFiles': 'Žádný soubor ke stažení',
      'downloadFile': 'Stáhnout soubor'
    },
    dropzone: {
      'dragAndDropFile': 'Sem přetáhněte obrázek, nebo klikněte pro výběr obrázku.',
      'maxFileSizeExceeded': 'Maximální povolená velikost souboru je {0} bytů. Váš soubor má {1} bytů.'
    },
    dashboard: {
      'title': 'Dashboard',
      'bottlesFormat': '{0}ks',
      'topSuppliers_title': 'Největší dodavatelé',
      'topSuppliers_byBottles': 'Podle počtu lahví',
      'topSuppliers_byPrices': 'Podle pořizovací ceny',
      'storageStatuses_title': 'Stav skladů',
      'soldByChannels_title': 'Prodejní kanály',
      'soldByChannels_channel': 'Kanál',
      'soldByChannels_bottles': 'Lahví',
      'soldByChannels_acquisition': 'Pořizovací cena (bez DPH)',
      'soldByChannels_actual': 'Prodejní cena (bez DPH)',
      'sellsByTime_title': 'Prodeje',
      'sellsByTime_range': 'Období',
      'sellsByTime_allTheTime': 'Za celou dobu',
      'sellsByTime_lastYear': 'V loňském roce',
      'sellsByTime_thisYear': 'V tomto roce',
      'sellsByTime_lastMonth': 'Minulý měsíc',
      'sellsByTime_lastWeek': 'Minulý týden',
      'sellsByTime_yesterday': 'Včera',
      'sellsByTime_customRange': 'V daném období',
      'bottlesByStatus_title': 'Objednané lahve',
      'bottlesByStatus_name': 'Název vína',
      'bottlesByStatus_bottlesCount': 'Počet lahví',
      'bottlesByStatus_totalPrice': 'Pořizovací cena (bez DPH)',
      'totals': 'CELKEM'
    },
    winesInStock: {
      'title': 'Vína na skladě',
      'bottlesInStockCount': 'Počet lahví',
      'bottlesOfWineInStockTitle': 'Počet lahví ve skladech',
      'suppliers': 'Dodavatelé',
      'storagePlace': 'Sklad',
      'bottlesCount': 'Počet lahví',
      'total': 'Celkem'
    }
  }
}

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    default: return state
  }
}

const getLocalization = (key, data) => {
  if (!key) { return `--KEY IS NULL!--` }
  const parts = key.split('.')
  if (!data[parts[0]]) { return null }
  return data[parts[0]][parts[1]]
}

export const localize = (localization, key) => getLocalization(key, localization.data) || `[${key}]`